var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.94922 6.97656H7.64922",
    stroke: "#8E9AA8",
    strokeWidth: 1.275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9627 7.65156H13.2063C12.0014 7.65156 11.0254 8.55809 11.0254 9.67656C11.0254 10.795 12.0021 11.7016 13.2056 11.7016H14.9627C15.0194 11.7016 15.047 11.7016 15.0707 11.7002C15.4352 11.6779 15.7254 11.4086 15.749 11.0704C15.7504 11.0488 15.7504 11.0225 15.7504 10.9705V8.38259C15.7504 8.33061 15.7504 8.30429 15.749 8.28269C15.7247 7.94451 15.4352 7.67519 15.0707 7.65291C15.047 7.65156 15.0194 7.65156 14.9627 7.65156Z",
    stroke: "#8E9AA8",
    strokeWidth: 1.275
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0514 7.65156C14.9987 6.38796 14.83 5.61306 14.2839 5.06766C13.4935 4.27656 12.2204 4.27656 9.675 4.27656H7.65C5.10458 4.27656 3.83152 4.27656 3.0411 5.06766C2.25 5.85809 2.25 7.13114 2.25 9.67656C2.25 12.222 2.25 13.495 3.0411 14.2855C3.83152 15.0766 5.10458 15.0766 7.65 15.0766H9.675C12.2204 15.0766 13.4935 15.0766 14.2839 14.2855C14.83 13.7401 14.9994 12.9652 15.0514 11.7016",
    stroke: "#8E9AA8",
    strokeWidth: 1.275
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94922 4.27692L7.47034 2.60494C7.8249 2.37432 8.23876 2.25156 8.66172 2.25156C9.08468 2.25156 9.49854 2.37432 9.85309 2.60494L12.3742 4.27692",
    stroke: "#8E9AA8",
    strokeWidth: 1.275,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0449 9.67681H13.0524",
    stroke: "#8E9AA8",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.6a0595107e44179b71caa2e794d5a043.svg";
export { ForwardRef as ReactComponent };